import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { omitGlobalPagesFromProfileGroupPages } from 'app/modules/analytics/utils/analyticsNonGlobalProfileGroups';
import type { PageData, ProfileGroupPage } from 'types/Page';

const ANALYTICS_PERFORMANCE_PAGE_TYPES = new Set<number>([
  TYPE.FACEBOOK,
  TYPE.INSTAGRAM,
  TYPE.LINKEDIN,
  TYPE.TIKTOK,
]);

const PLATFORM_SORT_ORDER: Record<number, number> = {
  [TYPE.FACEBOOK]: 0,
  [TYPE.INSTAGRAM]: 1,
  [TYPE.LINKEDIN]: 2,
  [TYPE.TIKTOK]: 3,
};

export function isAnalyticsPerformancePageType(type: number): boolean {
  return ANALYTICS_PERFORMANCE_PAGE_TYPES.has(type);
}

export function profileGroupPageToPageData(page: ProfileGroupPage): PageData {
  return {
    id: page.id,
    name: page.name,
    type: page.type,
    logo: page.logo,
    isConnected: page.isConnected ?? false,
    isDemo: false,
    isGlobal: page.isGlobal ?? false,
    isAutoschedule: false,
  };
}

export function sortProfileGroupPagesForPerformance(
  pages: ProfileGroupPage[],
): ProfileGroupPage[] {
  return [...pages].sort((a, b) => {
    if (!!a.isConnected !== !!b.isConnected) {
      return a.isConnected ? -1 : 1;
    }

    const orderA = PLATFORM_SORT_ORDER[a.type] ?? 99;
    const orderB = PLATFORM_SORT_ORDER[b.type] ?? 99;
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    return a.name.localeCompare(b.name);
  });
}

export function getSortedAnalyticsPerformancePagesFromGroupPages(
  pages: ProfileGroupPage[] | undefined,
): ProfileGroupPage[] {
  const list = omitGlobalPagesFromProfileGroupPages(pages ?? []);
  return sortProfileGroupPagesForPerformance(
    list.filter((p) => isAnalyticsPerformancePageType(p.type)),
  );
}

export function getUniquePageTypesForIcons(
  pages: ProfileGroupPage[],
): number[] {
  const seen = new Set<number>();
  const result: number[] = [];
  for (const p of sortProfileGroupPagesForPerformance(pages)) {
    if (!seen.has(p.type)) {
      seen.add(p.type);
      result.push(p.type);
    }
  }
  return result;
}
